import { notificationsAPI } from '@/lib/api';

const toBytes = (b64) => {
  const pad = '='.repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

export const pushSupported = () => 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

export const pushPermission = () => (pushSupported() ? Notification.permission : 'unsupported');

const subscribeDevice = async () => {
  const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await notificationsAPI.publicKey();
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toBytes(data.public_key) });
  }
  const json = sub.toJSON();
  await notificationsAPI.subscribe({ endpoint: json.endpoint, keys: json.keys });
};

export const enablePush = async () => {
  if (!pushSupported()) throw new Error('This browser does not support pop-up notifications. On iPhone, first tap Share → Add to Home Screen, then open the app from there.');
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Notifications are blocked. Allow them in your browser settings for this site.');
  await subscribeDevice();
};

export const refreshPushSubscription = () => {
  if (pushPermission() === 'granted') subscribeDevice().catch(() => {});
};
